/* Stylesheet */

.content {
  h6 {
    margin: 12px 0px 21px 0px;
  }

  u {
    line-height: 2.5;
  }

  span {
    font-weight: 500;
    font-style: italic;
  }
}
